import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import * as RadixToast from '@radix-ui/react-toast';
import { HistoryRouter } from './HistoryRouter.jsx';
import { ScrollToTop } from './ScrollToTop.jsx';
import { RouteTracker } from './RouteTracker.jsx';
import { PreviewModeBoot } from './PreviewModeBoot.jsx';
import { NativeBoot } from './NativeBoot.jsx';
import { ThemeProvider } from './theme.jsx';
import { store, persistor } from './store.js';
import { history } from '../lib/history.js';
import { ToastViewport } from '../ui/ToastViewport.jsx';

export function Providers({ children }) {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <PersistGate loading={null} persistor={persistor}>
          <HistoryRouter history={history}>
            <RadixToast.Provider swipeDirection="right">
              <ScrollToTop />
              <PreviewModeBoot />
              <NativeBoot />
              <RouteTracker />
              {children}
              <ToastViewport />
            </RadixToast.Provider>
          </HistoryRouter>
        </PersistGate>
      </ThemeProvider>
    </Provider>
  );
}
